import { render, staticRenderFns } from "./download.vue?vue&type=template&id=3844994f&"
import script from "./download.vue?vue&type=script&lang=ts&"
export * from "./download.vue?vue&type=script&lang=ts&"
import style0 from "./download.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports